.<template>
  <div>
    <v-form @submit.prevent="save">
      <v-card class="px-2">
        <v-card-title>
          <div class="text-subtitle-2">
            <span class="secondary-font font-weight-bold">{{ $t("account.security.title") }}</span>
          </div>
        </v-card-title>
        <v-card-subtitle class="grey--text text--darken-1">
          <span>{{ $t("account.security.description") }}</span>
        </v-card-subtitle>
        <v-card-text class="mt-4">
          <v-text-field
            class="font-weight-bold mb-1"
            :label="$i18n.t('security.fields.password.title')"
            v-model="form.oldPassword"
            type="password"
            autocomplete="off"
            outlined
            dense
            append-icon="mdi-shield-account-outline"
            @input="delayTouch($v.form.oldPassword)"
            @blur="$v.form.oldPassword.$touch"
            :error-messages="oldPasswordErrors"
          ></v-text-field>
          <v-text-field
            class="font-weight-bold mb-1"
            :label="$i18n.t('security.fields.new_password.title')"
            v-model="form.password"
            type="password"
            autocomplete="off"
            outlined
            dense
            append-icon="mdi-shield-account-outline"
            @input="delayTouch($v.form.password)"
            @blur="$v.form.password.$touch"
            :error-messages="passwordErrors"
          ></v-text-field>
          <v-text-field
            class="font-weight-bold mb-1"
            :label="$i18n.t('security.fields.confirm_password.title')"
            v-model="form.confirmPassword"
            type="password"
            autocomplete="off"
            outlined
            dense
            append-icon="mdi-shield-account-outline"
            @input="delayTouch($v.form.confirmPassword)"
            @blur="$v.form.confirmPassword.$touch"
            :error-messages="confirmPasswordErrors"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="submit" :loading="loading.save" text color="primary">{{ $t('btn.edit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import {
  required,
  minLength,
  sameAs,
  maxLength
} from "vuelidate/lib/validators";
import FormDelayTouchMixin from "./../../mixins/commons/form-delay-touch";
import FormMixin from "./../../mixins/commons/form";
export default {
  mixins: [FormDelayTouchMixin, FormMixin],
  data: () => ({
    form: {
      oldPassword: null,
      password: null,
      confirmPassword: null
    },
    loading: {
      save: false
    }
  }),
  validations: {
    form: {
      oldPassword: {
        required
      },
      password: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(30)
      },
      confirmPassword: {
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    getPath() {
      return "/api/users/change-password";
    },
    getMessages() {
      return {
        200: this.$t("account.security.edit.success"),
        403: true,
        400: true,
        422: (error) => {
          if(error.code === 'E100') {
            return this.$t('security.fields.password.invalid')
          }
          return this.$t('errors.500E')
        }
      };
    },
    preSubmit() {
      this.loading.save = true;
    },
    postSubmit() {
      this.loading.save = false;
      this.resetForm();
    },
    getData(form) {
      return {
        password: form.password,
        old_password: form.oldPassword
      };
    },
    resetForm() {
      this.$v.form.$reset();
      for (const prop in this.form) {
        this.form[prop] = null;
      }
    }
  },
  computed: {
    oldPasswordErrors() {
      const errors = [];
      if (!this.$v.form.oldPassword.$dirty) return errors;

      if (!this.$v.form.oldPassword.required)
        errors.push(this.$i18n.t("security.fields.password.required"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.form.password.$dirty) return errors;

      !this.$v.form.password.required &&
        errors.push(this.$i18n.t("security.fields.new_password.required"));

      !this.$v.form.password.minLength &&
        errors.push(
          this.$i18n.t("security.fields.password.min_length", {
            min: this.$v.form.password.$params.minLength.min
          })
        );
      
      !this.$v.form.password.maxLength &&
        errors.push(
          this.$i18n.t("security.fields.password.max_length", {
            min: this.$v.form.password.$params.maxLength.max
          })
        );
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.form.confirmPassword.$dirty) return errors;

      !this.$v.form.confirmPassword.sameAsPassword &&
        errors.push(this.$i18n.t("security.fields.confirm_password.same_as"));
      return errors;
    }
  }
};
</script>